import { render, staticRenderFns } from "./MarriagesIncomeRow.vue?vue&type=template&id=229c2e2c&"
import script from "./MarriagesIncomeRow.vue?vue&type=script&lang=js&"
export * from "./MarriagesIncomeRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports